export const EMPTY_FIXATION_PRICING_DEFAULTS = Object.freeze({
  fixationOption: "",
  percentage: "",
  lmePrice: "",
  lme3Month: "",
  cashPrice: ""
});

export const buildFixationPricingDefaults = (sourceDeal = {}, items = []) => {
  const deal = sourceDeal || {};
  const itemRows = Array.isArray(items) ? items : [];
  const firstItem = itemRows[0] || {};
  const firstUnfixedItem = itemRows.find((item) =>
    (item.priceMode || item.PriceMode) === "UnFixed" && (item.lmeOption || item.LMEOption || item.lme || item.LME)
  ) || itemRows.find((item) => (item.priceMode || item.PriceMode) === "UnFixed") || {};
  const itemLme = firstUnfixedItem.lme || firstUnfixedItem.LME || firstItem.lme || firstItem.LME || "";
  // priceAdjustmentValue is always the "Per Of LME" percentage.
  const itemPercentage = firstUnfixedItem.priceAdjustmentValue ?? firstUnfixedItem.PriceAdjustmentValue ?? "";
  const priceMode = deal.priceMode || deal.PriceMode || "";
  const isPercent = deal.isPercent ?? deal.IsPercent;
  const dealLmeOption = deal.lmeOption || deal.LMEOption || "";
  const itemLmeOption = firstUnfixedItem.lmeOption || firstUnfixedItem.LMEOption || "";

  return {
    fixationOption: priceMode === "UnFixed"
      ? dealLmeOption || itemLmeOption || ""
      : itemLmeOption || dealLmeOption || "",
    percentage: itemPercentage !== "" ? itemPercentage
      : priceMode === "UnFixed" && (isPercent === true || Number(isPercent) === 1)
        ? 100 - Number(deal.unFixedAmount ?? deal.UnFixedAmount ?? 0) : "",
    lmePrice: itemLme,
    lme3Month: itemLme,
    cashPrice: itemLme
  };
};
